import { forwardRef } from 'react'
import * as Styled from './styled'
import { IProps } from './types'

const Button = forwardRef<HTMLButtonElement, IProps>(
  ({ children, type = 'primary', isDisabled, onClick, className }, ref) => {
    return (
      <Styled.Button
        ref={ref}
        onClick={onClick}
        $isDisabled={isDisabled}
        $type={type}
        className={className}
      >
        {children}
      </Styled.Button>
    )
  }
)
Button.displayName = 'Button'

export default Button
